var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 496.8 496.8",
    viewBox: "0 0 496.8 496.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M496 357.6c0 24.8-20 41.6-44.8 41.6H44.8C20 399.2 0 381.6 0 357.6V136.8c0-24 20-41.6 44.8-41.6H452c24.8 0 44.8 17.6 44.8 41.6v220.8h-.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 138.4c0-24.8 20-43.2 44.8-43.2H452c24.8 0 44.8 17.6 44.8 41.6v220c0 24.8-20 44.8-44.8 44.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E6664",
    d: "M0 151.2H496V231.2H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F423F",
    d: "M496 231.2L496 151.2 0 151.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15249",
    d: "M91.2 315.2c0-19.2 10.4-35.2 25.6-44-7.2-4-16-7.2-25.6-7.2-28 0-51.2 23.2-51.2 51.2s23.2 51.2 51.2 51.2c9.6 0 18.4-2.4 25.6-7.2-15.2-8-25.6-24.8-25.6-44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#525289",
    d: "M142.4 264c-9.6 0-18.4 2.4-25.6 7.2 15.2 8.8 25.6 25.6 25.6 44 0 19.2-10.4 35.2-25.6 44 7.2 4 16 7.2 25.6 7.2 28 0 51.2-23.2 51.2-51.2 0-28-23.2-51.2-51.2-51.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.26b075990f822686f1c8a634d0d463bb.svg";
export { ForwardRef as ReactComponent };